import { state } from '@angular/animations';
import { Component, OnInit, NgModule, ViewChild, enableProdMode, OnDestroy } from '@angular/core';
import { SubscriptionService } from '../../../shared/services/subscription.service';
import { CommonService } from '../../../shared/services/common.service';
import { DashboardService } from '../../../services/dashboard.service';
import { ProfileService } from '../../../services/profile.service';
import { Utilities } from '../../../../app/Utilities';
import { DxDataGridComponent, DxDataGridModule, DxSelectBoxModule, DxSelectBoxComponent } from 'devextreme-angular';
import { CustomNotification } from '../../../CustomNotification';
import { Router } from '@angular/router';
import { Route } from '@angular/router/src/config';
import { ChangePasswordModel } from '../../../models/ChangePasswordModel';
import { Subscription } from 'rxjs/Subscription';
import { CoBuyerService } from '../../../services/Co-Buyer.service';
export class ContactInfoModel {
  public BuyerAdditionalContactID: number;
  public CRMContactTypeLookupID: number;
  public Type: string;
  public ContactInfo: string;
  public Status: string;
  public uniqueId: any;
}


export class BuyerModel {
  public BuyerID: number;
  public Title: string;
  public FirstName: string;
  public LastName: string;
  public MiddleName: string;
  public Phone: string;
  public EmailAddress: string;
  public Suffix: string;
  public PrimaryAddress1: string;
  public PrimaryAddress2: String;
  // public PrimaryCityID: number;
  // public PrimaryStateID: number;
  public PrimaryCityName: string;
  public PrimaryStateName: string;
  public PrimaryCountryID: number;
  public PrimaryZipCode: string;
  public SecondaryAddress1: string;
  public SecondaryAddress2: String;
  // public SecondaryCityID: number;
  // public SecondaryStateID: number;
  public SecondaryCityName: string;
  public SecondaryStateName: string;
  public SecondaryCountryID: number;
  public SecondaryZipCode: string;
  public OrganizationsID: number;
  public IsCall: boolean;
  public IsText: boolean;
  public IsEmail: boolean;
  public Status: string;
  public CreatedFrom: string='BW';
  public MobileServiceProviderID: number;
  public IsCobuyer:boolean;
  public CoBuyerID:number=0;
  
}
export class CoBuyerInfoModel {
  public CoBuyerID: number;
  public BuyerID: number;
  public Title: string;
  public FirstName: string;
  public LastName: string;
  public MiddleName: string;
  public Phone: string;
  public EmailAddress: string;
  public Suffix: string;
  public Address1: string;
  public Address2: String;
  // public CityID: number;
  // public StateId: number;
  public City: string;
  public State: string;
  public CountryId: number;
  public ZipCode: string;
  public ContactPreference: string;
  public Status: string;
  public IsText: boolean;
  public IsCall: boolean;
  public IsEmail: boolean;
  public uniqueId: any;
  public CommunityLotID: number;
  public ContractID: number;
  public CreatedFrom: string='BW';
  public PrimaryStateName : string;
  public PrimaryCityName:string;
  public UserId: number;
  public CopyFromCoBuyerID : number=0;
}
export class LookupModel {
  public LookupID: number;
  public LookupValue: string;
}

export class MobileProviderViewModel {
  public ID: number;
  public Name: string;
}

export class BuyerViewModel {
  public buyeradditionalcontactinfo: ContactInfoModel[];
  public coBuyerInfoList: CoBuyerInfoModel[];
  public buyer: BuyerModel;
}
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, OnDestroy {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild("mobileProvidersSelectBox") mobileProvidersSelectBox: DxSelectBoxComponent;
  BuyerView: BuyerViewModel;
  profile: BuyerModel;

  OrganizationList: any[] = [];

  CountryList: any[] = [];
  StateList: any[] = [];
  CityList: any[] = [];

  ContactInfoModelList: ContactInfoModel[] = [];
  contactInfoModel: ContactInfoModel = null;

  contactInfoPopupVisible = false;
  CoBuyerInfoPopupVisible = false;
  public changePasswordPopupVisible = false;

  CoBuyerInfoModel: CoBuyerInfoModel = null;
  CoBuyerInfoModelList: CoBuyerInfoModel[] = [];
  CoBuyerInfoDeleteModelList: CoBuyerInfoModel[] = [];
  public changePassword: ChangePasswordModel = null;

  AdditonalContactTypeList: LookupModel[] = [];
  MobileProvideList: MobileProviderViewModel[] = [];

  usesubmitBehavior = true;

  TitleList: any[] = [];
  submitted = false;
  cobuyersubmitted = false;
  contactsubmitted = false;
  private subscriptions: Subscription[] = [];
  AuthUserObj: any = undefined;
  coBuyerPopupVisible = false;
  public Cobuyerheading:any;
  public Cobuyerheadinglist1:any;
  public Cobuyerheadinglist2:any;
  coBuyerMappingPopupVisible=false;
  MsgTitle='';
  public CommunityLotId: Number = 0;
  public CoBuyerList: any = [];
  constructor(public commonService: CommonService, public dashboardService: DashboardService, public subscriptionService: SubscriptionService
    , public profileService: ProfileService, public _router: Router,
    public coBuyerService: CoBuyerService,
    public customNotification: CustomNotification) {
      this.AuthUserObj = commonService.AuthUser.getValue();
  }
  passwordComparison = () => {
    return this.changePassword.NewPassword;
  };
  showSuccess() {
    this.customNotification.notify('everything is broken', "", 'error');
  }

  private getProfileDetails() {
    this.profileService.getBuyerContactType().subscribe(x => {
      if (x) {
        this.AdditonalContactTypeList = x;
      }
    })
    // this.AdditonalContactTypeList = [{ ID: 1830, Name: 'Email' }, { ID: 1829, Name: 'Mobile No.' }];
    this.TitleList = [{ ID: "Mr", Name: 'Mr.' }, { ID: "Mrs.", Name: 'Mrs.' }, { ID: "Miss.", Name: 'Miss.' }];

    // to handle null values
    this.profile = new BuyerModel();
    this.changePassword = new ChangePasswordModel();
    this.CommunityLotId=this.subscriptionService.CommunityLotId$.getValue();
    console.log(this.CommunityLotId);
    
    this.subscriptions.push(this.profileService.GetProfileDetail(this.CommunityLotId).subscribe(buyer => {
      if (buyer) {
        this.profile = buyer.buyer;
        
        this.OrganizationList = buyer.OrganizationList;
        this.ContactInfoModelList = [];
        buyer.buyeradditionalcontactinfo.forEach(element => {
          element.uniqueId = Utilities.generateGuid();
          this.ContactInfoModelList.push(element);
        });
        this.CoBuyerInfoModelList = [];
        buyer.coBuyerInfoList.forEach(element => {
          element.uniqueId = Utilities.generateGuid();
          this.CoBuyerInfoModelList.push(element);
        });;
        this.CountryList = buyer.CountryList;
        //this.MobileProvideList=buyer.MobileProviderList;
        // this.StateList = buyer.StateList;
        // this.CityList = buyer.CityList;
      }
      else {
        this.profile = new BuyerModel();
      }
    }));

  }
  ngOnInit() {
    this.getProfileDetails();
  }

  GetMobileProvideByCountryID(CountryID: number) {
    if (CountryID) {
      this.profileService.GetMobileProvideByCountryID(CountryID).subscribe(x => {
        this.MobileProvideList = x ? x : [];
        this.profile.MobileServiceProviderID = this.MobileProvideList.length === 0 ? 0 : this.profile.MobileServiceProviderID;
      });
    }
  }
  SaveProfile(profileForm) {
    this.submitted = true;
    if (profileForm.valid) {
      this.BuyerView = new BuyerViewModel();
      this.BuyerView.buyer = this.profile;
      this.BuyerView.buyeradditionalcontactinfo = this.ContactInfoModelList;
      this.BuyerView.coBuyerInfoList = this.CoBuyerInfoModelList;

      this.CoBuyerInfoDeleteModelList.forEach(element => {
        this.BuyerView.coBuyerInfoList.push(element);
      });
   
      this.subscriptions.push(this.dashboardService.SaveProfile(this.BuyerView).subscribe(result => {
          if(result.status){
          this.BuyerView = new BuyerViewModel();
          this.customNotification.notify(result.message, '', Utilities.success);
          this.submitted = false;
          this.getProfileDetails();
        }
        else{
          this.BuyerView = new BuyerViewModel();
          this.customNotification.notify(result.message, '', Utilities.error);
          this.submitted = false;
        }
      }));
    }
  }

  onShown(event: any) {
    Utilities.setTitleDxPopup(event);
  }

  GetCityByStateId(StateID: number) {
    this.subscriptions.push(this.commonService.GetCityByStateId(StateID).subscribe(city => {
      this.CityList = city ? city.City_StateList : [];
    }));
  }

  GetStateByCountryId(CountryID: number) {
    this.subscriptions.push(this.commonService.GetStateByCountryId(CountryID).subscribe(state => {
      this.StateList = state ? state.City_StateList : [];
    }));
  }


  AddEditContactInfo(model) {
    this.usesubmitBehavior = true;
    this.contactInfoModel = null;
    this.contactInfoPopupVisible = true;
    if (model)
      this.contactInfoModel = model;
    else {
      this.contactInfoModel = new ContactInfoModel();
      // this.contactInfoModel.CRMContactTypeLookupID=undefined;
      // this.contactInfoModel.ContactInfo="";
    }

  }

  AddEditCoBuyerInfo(model) {
    this.cobuyersubmitted = false;
    this.CoBuyerInfoPopupVisible = true;
    if (model)
      this.CoBuyerInfoModel = model.data;
    else
      this.CoBuyerInfoModel = new CoBuyerInfoModel();
  }

  SaveContactInfo(contactForm) {

    this.contactsubmitted = true;
    if (contactForm.valid) {
      this.contactsubmitted = false;
      var type = this.AdditonalContactTypeList.find(x => x.LookupID == this.contactInfoModel.CRMContactTypeLookupID).LookupValue;
      if (!!this.contactInfoModel.BuyerAdditionalContactID == false) {
        //this.contactInfoModel.BuyerAdditionalContactID=this.ContactInfoModelList.length+1;
        if (this.contactInfoModel.BuyerAdditionalContactID == 0) {
          this.contactInfoModel.Type = type;
          this.ContactInfoModelList.filter(x => x.uniqueId == this.contactInfoModel.uniqueId)[0].ContactInfo = this.contactInfoModel.ContactInfo;
          this.ContactInfoModelList.filter(x => x.uniqueId == this.contactInfoModel.uniqueId)[0].CRMContactTypeLookupID = this.contactInfoModel.CRMContactTypeLookupID;
        }
        else {
          this.contactInfoModel.BuyerAdditionalContactID = 0;
          this.contactInfoModel.Type = type;
          this.contactInfoModel.uniqueId = Utilities.generateGuid();
          this.ContactInfoModelList.push(this.contactInfoModel);
        }

      }
      else {
        this.ContactInfoModelList.filter(x => x.uniqueId == this.contactInfoModel.uniqueId)[0].ContactInfo = this.contactInfoModel.ContactInfo;

        this.ContactInfoModelList.filter(x => x.uniqueId == this.contactInfoModel.uniqueId)[0].CRMContactTypeLookupID = this.contactInfoModel.CRMContactTypeLookupID;
        this.ContactInfoModelList.filter(x => x.uniqueId == this.contactInfoModel.uniqueId)[0].Type = type;
      }
      this.contactInfoModel = new ContactInfoModel();
      this.usesubmitBehavior = false;
      this.contactInfoPopupVisible = false;
    }
  }

  SaveCoBuyerInfo(coBuyerForm) {
    this.cobuyersubmitted = true;
    if (coBuyerForm.valid) {
      this.cobuyersubmitted = false;
      // if (!!this.CoBuyerInfoModel.CoBuyerID == false) {
        
      //   if (this.CoBuyerInfoModel.CoBuyerID == 0) {
      //     this.CoBuyerInfoModel.CoBuyerID = 0;


      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Title = this.CoBuyerInfoModel.Title;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].LastName = this.CoBuyerInfoModel.LastName;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].FirstName = this.CoBuyerInfoModel.FirstName;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].MiddleName = this.CoBuyerInfoModel.MiddleName;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Suffix = this.CoBuyerInfoModel.Suffix;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Address1 = this.CoBuyerInfoModel.Address1;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Address2 = this.CoBuyerInfoModel.Address2;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].City = this.CoBuyerInfoModel.City;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].State = this.CoBuyerInfoModel.State;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].CountryId = this.CoBuyerInfoModel.CountryId;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Phone = this.CoBuyerInfoModel.Phone;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].EmailAddress = this.CoBuyerInfoModel.EmailAddress;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].IsText = this.CoBuyerInfoModel.IsText;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].IsCall = this.CoBuyerInfoModel.IsCall;
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].IsEmail = this.CoBuyerInfoModel.IsEmail;

      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].CommunityLotID = this.subscriptionService.CommunityLotId$.getValue();
      //     this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].ContractID = this.subscriptionService.ContractID$.getValue();

      //   }
      //   else {
      //     this.CoBuyerInfoModel.CoBuyerID = 0;
         
      //     this.CoBuyerInfoModel.uniqueId = Utilities.generateGuid();
      //     this.CoBuyerInfoModelList.push(this.CoBuyerInfoModel);
      //   }
      // }
      // else {
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Title = this.CoBuyerInfoModel.Title;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].LastName = this.CoBuyerInfoModel.LastName;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].FirstName = this.CoBuyerInfoModel.FirstName;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].MiddleName = this.CoBuyerInfoModel.MiddleName;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Suffix = this.CoBuyerInfoModel.Suffix;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Address1 = this.CoBuyerInfoModel.Address1;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Address2 = this.CoBuyerInfoModel.Address2;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].City = this.CoBuyerInfoModel.City;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].State = this.CoBuyerInfoModel.State;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].CountryId = this.CoBuyerInfoModel.CountryId;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Phone = this.CoBuyerInfoModel.Phone;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].EmailAddress = this.CoBuyerInfoModel.EmailAddress;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].IsText = this.CoBuyerInfoModel.IsText;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].IsCall = this.CoBuyerInfoModel.IsCall;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].IsEmail = this.CoBuyerInfoModel.IsEmail;
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].Status = this.CoBuyerInfoModel.Status;

      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].CommunityLotID = this.subscriptionService.CommunityLotId$.getValue();
      //   this.CoBuyerInfoModelList.filter(x => x.uniqueId == this.CoBuyerInfoModel.uniqueId)[0].ContractID = this.subscriptionService.ContractID$.getValue();
      // }
      // this.CoBuyerInfoModel = new CoBuyerInfoModel();

      this.CoBuyerInfoModel.CommunityLotID = this.subscriptionService.CommunityLotId$.getValue();
      this.CoBuyerInfoModel.ContractID = this.subscriptionService.ContractID$.getValue();
      this.CoBuyerInfoModel.PrimaryStateName=this.CoBuyerInfoModel.State;
      this.CoBuyerInfoModel.PrimaryCityName=this.CoBuyerInfoModel.City;
        
      if(this.CoBuyerInfoModel.BuyerID===0 || this.CoBuyerInfoModel.BuyerID == undefined){
        this.CoBuyerInfoModel.BuyerID=this.profile.BuyerID;
    }
      this.subscriptions.push(this.coBuyerService.saveCoBuyerInfo(this.CoBuyerInfoModel).subscribe(x => {
        
        if(!x.status){
          this.customNotification.notify(x.message, "", Utilities.error); 
           }
        else{
          this.submitted = false;
          this.CoBuyerInfoModel.CountryId = 0;
          this.CoBuyerInfoPopupVisible = false;
          this.customNotification.notify(x.message, "", Utilities.success);
          this.getProfileDetails();
        }
      }));
      this.getProfileDetails(); 
      // this.CoBuyerInfoPopupVisible = false;
    }
    this.getProfileDetails(); 
  }

  deleteCobuyerInfo(uniyqueId: any) {
    Utilities.confirm("Are you sure?", "Remove Co-Buyer Info.").then(x => {
      if (x) {
        this.CoBuyerInfoModelList.filter(x => x.uniqueId == uniyqueId)[0].Status = "InActive";
        const index: number = this.CoBuyerInfoModelList.indexOf(this.CoBuyerInfoModelList.find(x => x.uniqueId == uniyqueId));
        if (index !== -1) {
          this.CoBuyerInfoDeleteModelList.push(this.CoBuyerInfoModelList.find(x => x.uniqueId == uniyqueId));
          this.CoBuyerInfoModelList.splice(index, 1);
        }
      }
    });

  }

  ClosePopup() {
    this.CoBuyerInfoPopupVisible = false;
    this.contactInfoPopupVisible = false;

    this.cobuyersubmitted = false;
    this.contactsubmitted = false;

    this.changePasswordPopupVisible = false;
    //this.useSubmitBehavior=false
  }
  ClosePopup1() {
    this.CoBuyerInfoPopupVisible = false;
    this.contactInfoPopupVisible = false;

    this.cobuyersubmitted = false;
    this.contactsubmitted = false;

    this.changePasswordPopupVisible = false;
    this.getProfileDetails();
  }
  onCancel() {
    this._router.navigate(['/dashboard']);
  }

  public onChangePassword() {
    this.changePasswordPopupVisible = true;
    this.changePassword.EmailId = this.profile.EmailAddress;
  }

  public onSaveChangePassord(changePasswordForm) {
    if (changePasswordForm.valid) {
      var temp = this.changePassword;
      this.subscriptions.push(this.profileService.ChangePassword(this.changePassword).subscribe(x => {
        this.customNotification.notify(x.Message, "", Utilities.success);
        this.changePassword = new ChangePasswordModel();
        this.changePasswordPopupVisible = false;
      }));
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  CheckCoBuyerEmailAddress(event: any){
  
    this.subscriptions.push(this.coBuyerService.CheckCoBuyerEmailAddress(event.target.value,this.CoBuyerInfoModel.CoBuyerID).subscribe(x => {
      
      this.MsgTitle = "Existing Co-Buyer(s)";
      this.Cobuyerheading="Co-Buyer(s) having "+ this.CoBuyerInfoModel.EmailAddress+ " email address are already exists in our system and those are shown below.";
      this.Cobuyerheadinglist1="If the Co-Buyer which you are trying to assign to this lot is any of below Co-Buyer(s) then please select that Co-Buyer and click on ‘Select’. This will prepopulate that Co-Buyer’s details in ‘Co-Buyer’ form.";
      this.Cobuyerheadinglist2="If it is not any of below Co-Buyer(s) then click on ‘Cancel’.";
      if(x.data.length>0){
        this.CoBuyerList = x.data;
        this.coBuyerMappingPopupVisible = true;
        
      }
      else{
        this.CoBuyerInfoModel.CopyFromCoBuyerID=0;
       return
      }
      
      this.getProfileDetails(); 
    }));
    //console.log(event.target.value);
 
 }
 SaveData(event: any){
  console.log(event);

  this.CoBuyerInfoModel.CopyFromCoBuyerID=event.CoBuyerID;
  this.CoBuyerInfoModel.Title=event.Title;
  this.CoBuyerInfoModel.FirstName=event.FirstName;
  this.CoBuyerInfoModel.MiddleName=event.MiddleName;
  this.CoBuyerInfoModel.LastName=event.LastName;
  this.CoBuyerInfoModel.Address1=event.Address1;
  this.CoBuyerInfoModel.Address2=event.Address2;
  this.CoBuyerInfoModel.CountryId=event.CountryId;
  this.CoBuyerInfoModel.PrimaryStateName=event.PrimaryStateName;
  this.CoBuyerInfoModel.PrimaryCityName=event.PrimaryCityName;
  this.CoBuyerInfoModel.ZipCode=event.ZipCode;
  this.CoBuyerInfoModel.Phone=event.Phone;
  this.CoBuyerInfoModel.EmailAddress=event.EmailAddress;
  this.CoBuyerInfoModel.IsEmail=event.IsEmail;
  this.CoBuyerInfoModel.IsText=event.IsText;
  this.CoBuyerInfoModel.IsCall=event.IsCall;
  this.coBuyerMappingPopupVisible = false;
 }
 CloseMappingPopup(){
    this.coBuyerMappingPopupVisible = false;
    this.AddEditCoBuyerInfo(this.CoBuyerInfoModel.CoBuyerID);
      // Utilities.confirm("Since you have clicked on ‘Cancel’ button, system will create a new CoBuyer and assign to this lot when you will click on ‘Submit’ button provided in ‘CoBuyer’ form. Are you sure?", "Message")
      // .then((x) => {
      //   if (x) {
      //     Utilities.alert('As you are not changing the Cobuyer. Hence, please revert back the Cobuyer details if you have changed',"Information");
      //     this.coBuyerMappingPopupVisible = false;
      //     this.AddEditCoBuyerInfo(this.CoBuyerInfoModel.CoBuyerID);
      //   }
      // });
 }

 SendMailToCoBuyerCredential(CoBuyerID) {

  this.CoBuyerInfoModel = new CoBuyerInfoModel();
  this.CoBuyerInfoModel.CommunityLotID = this.subscriptionService.CommunityLotId$.getValue();

  if (this.CoBuyerInfoModel.CommunityLotID) {

    if (CoBuyerID > 0) {
      this.subscriptions.push(this.coBuyerService.SendMailToCoBuyerCredential(CoBuyerID, this.CoBuyerInfoModel.CommunityLotID, 'BW').subscribe(x => {
        if (x.status) {
          this.customNotification.notify(x.message, "", Utilities.success);
          this.getProfileDetails();
        } else {
          this.customNotification.notify(x.message, "", Utilities.error);
        }
      }));
    }
  }

}
onRowPrepared(e) {
  // console.log("onRowPrepared",e);
  if (e.rowType === "data") {
      if (e.data.UserId ==0) {
          e.rowElement.style.backgroundColor = "#d9534f" ;
          e.rowElement.style.color = "white";
          // or
          //e.rowElement.classList.add("ChangeBgColor");
          // to override alternation color
          e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
      }
  }
}
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/profile/profile.component.ts